import { httpClient } from "./httpClient";

export function registerUser ({name, phone, password}) {
  return httpClient.post("/user/register", { name, phone, password });
}

export function loginUser({ phone, password }) {
  return httpClient.post("/user/login", { phone, password });
}

export function getCurrentUser() {
  return httpClient.get("/user/me");
}
